export enum BikeTypes {
    M_CARGO = 'M_CARGO',
    E_CARGO = 'E_CARGO',
    CHILD = 'CHILD',
    MECHANICAL = 'MECHANICAL',
    ELECTRICAL = 'ELECTRICAL',
    UNDEFINED = 'UNDEFINED'
}
